<template>
	<v-container fluid class="ma-0 pa-0">
		<Header />
    <v-col class="pa-0" id="main_content_maxwidthset" cols="12">
			<v-col class="ma-0 pa-2 pt-5 pl-5 pr-5 pb-2" cols="12">
				<v-col class="ma-0 pa-0 mb-5" cols="12" align="start"
					v-if="tokenExisted">
					<v-btn width="auto" height="auto" class="ma-0 pa-2 text-none" :loading="streamingUrlLoading"
						id="grey_btn" elevation="0" @click="goVideoTest">
						{{'Video Test Page'}}
					</v-btn>

					<v-btn width="auto" height="auto" class="ma-0 pa-2 ml-4 text-none"
						id="grey_btn" elevation="0" @click="goWebRTCVideo">
						{{'KVSWebRTC Video Test'}}
					</v-btn>
				</v-col>
				<v-col class="ma-0 pa-0 mb-5" cols="12">
					<v-row class="ma-0 pa-0" align="center">
						<v-col class="ma-0 pa-0" cols="1">{{ 'video.js - ' }}</v-col>
						<v-btn width="auto" height="auto" class="ma-0 pa-2 text-none" 
							id="grey_btn" elevation="0" @click="goMultiVideoTest(4, 'video')">
							{{'4 Video Viewer'}}
						</v-btn>
						<v-btn width="auto" height="auto" class="ma-0 pa-2 ml-4 text-none" 
							id="grey_btn" elevation="0" @click="goMultiVideoTest(9, 'video')">
							{{'9 Video Viewer'}}
						</v-btn>
						<v-btn width="auto" height="auto" class="ma-0 pa-2 ml-4 text-none" 
							id="grey_btn" elevation="0" @click="goMultiVideoTest(16, 'video')">
							{{'16 Video Viewer'}}
						</v-btn>
					</v-row>
				</v-col>
				<v-col class="ma-0 pa-0 mb-5" cols="12">
					<v-row class="ma-0 pa-0" align="center">
						<v-col class="ma-0 pa-0" cols="1">{{ 'hls.js - ' }}</v-col>
						<v-btn width="auto" height="auto" class="ma-0 pa-2 text-none" 
							id="grey_btn" elevation="0" @click="goMultiVideoTest(4, 'hls')">
							{{'4 Video Viewer'}}
						</v-btn>
						<v-btn width="auto" height="auto" class="ma-0 pa-2 ml-4 text-none" 
							id="grey_btn" elevation="0" @click="goMultiVideoTest(9, 'hls')">
							{{'9 Video Viewer'}}
						</v-btn>
						<v-btn width="auto" height="auto" class="ma-0 pa-2 ml-4 text-none" 
							id="grey_btn" elevation="0" @click="goMultiVideoTest(16, 'hls')">
							{{'16 Video Viewer'}}
						</v-btn>
					</v-row>
				</v-col>
				<v-col class="ma-0 pa-0 mb-5" cols="12"
					v-if="tokenExisted">
					<v-row class="ma-0 pa-0" align="center">
						<v-btn width="auto" height="auto" class="ma-0 pa-2 text-none" 
							id="grey_btn" elevation="0" @click="goVideoThumbnailTest">
							{{'Video Thumbnail'}}
						</v-btn>
						<v-btn width="auto" height="auto" class="ma-0 pa-2 ml-4"
							id="grey_btn" elevation="0" @click="goAllStoreAnalyticsTest">
							{{'전점포 페이지'}}
						</v-btn>
						<v-btn width="auto" height="auto" class="ma-0 pa-2 ml-4"
							id="grey_btn" elevation="0" @click="goFabricTest"
							:loading="streamingUrlLoading">
							{{'Fabric Test'}}
						</v-btn>
            <v-btn width="auto" height="auth" class="ma-0 pa-2 ml-4 text-none"
              id="grey_btn" elevation="0" @click="goWebRTCTest">
              {{'WebRTC Module'}}
            </v-btn>
					</v-row>
				</v-col>
				<v-divider id="middle_divider" class="ma-0 pa-0 mb-5"></v-divider>

				<v-col class="ma-0 pa-0 mb-5" cols="12">
					<v-row class="ma-0 pa-0" align="center">
						<v-btn width="auto" height="auto" class="ma-0 pa-2 text-none" 
							id="grey_btn" elevation="0" @click="snackbar = true">
							{{'기본 Snackbar'}}
						</v-btn>
						<v-snackbar v-model="snackbar" dark centered :timeout="2000">
							{{'Snackbar Test'}}
						</v-snackbar>
						<v-btn width="auto" height="auto" class="ma-0 pa-2 ml-4 text-none" 
							id="grey_btn" elevation="0" @click="testToast">
							{{'Custom Toast Test'}}
						</v-btn>
						<v-btn width="auto" height="auto" class="ma-0 pa-2 ml-4 text-none" 
							id="grey_btn" elevation="0" @click="testConfirmDialog">
							{{'Comfirm Dialog'}}
						</v-btn>
						<v-btn width="auto" height="auto" class="ma-0 pa-2 ml-4 text-none" 
							id="grey_btn" elevation="0" @click="testInfoDialog">
							{{'Info Dialog'}}
						</v-btn>
						<v-btn width="auto" height="auto" class="ma-0 pa-2 ml-4 text-none" 
							id="grey_btn" elevation="0" @click="testOverlayLoading">
							{{'Overlay Loading Test'}}
						</v-btn>
						<v-btn width="auto" height="auto" class="ma-0 pa-0 text-none" 
							id="back_clean_btn" elevation="0">
							<v-img max-height="2rem" max-width="2rem" class="ma-0 pa-0"
								src="@/assets/images/calendar.png"></v-img>
						</v-btn>
					</v-row>
				</v-col>
				<v-col class="ma-0 pa-0 mb-5" cols="12">
					<v-col class="ma-0 pa-0" cols="12" align="left">{{ 'Loader Test' }}</v-col>
					<ImageSkeleton :loaderCount="3" width='100%' height='9rem' />
				</v-col>
				<v-col class="ma-0 pa-0 mb-5" cols="4">
					<v-row class="ma-0 pa-0" align="center" justify="start">
						<v-col class="ma-0 pa-0" cols="3" @click="openTimePicker('begin')">
							<v-text-field v-model="beginTimeValue" dark hide-details dense outlined
								append-icon="mdi-menu-down"
								readonly background-color="#272727" style="font-size:0.7rem;">
							</v-text-field>
						</v-col>
				  	<v-col class="ma-0 pa-0 pl-1 pr-1" cols="1" align="center">{{'~'}}</v-col>
						<v-col class="ma-0 pa-0" cols="3" @click="openTimePicker('end')">
							<v-text-field v-model="endTimeValue" dark hide-details dense outlined
								append-icon="mdi-menu-down"
								readonly background-color="#272727" style="font-size:0.7rem;">
							</v-text-field>
						</v-col>
					</v-row>
				</v-col>
			</v-col>
		</v-col>

		<TimePicker :dialogVisible="timePickerDialogVisible"
      @visible="timePickerDialogVisibleFunc" @timeValue="timeValueFunc" />
	</v-container>
</template>

<script>
import mixin from '@/mixin';
import Header from '@/views/admin/Header.vue'
import ImageSkeleton from '@/components/loader/ImageSkeleton.vue';
import TimePicker from '@/components/dialogs/TimePicker.vue';
import $ from 'jquery';
export default {
	components: {
		Header, ImageSkeleton, TimePicker
	},
	mixins: [mixin.common],
	data: () => ({
		snackbar: false,
		streamingUrlLoading: false,
		streamList: [],
		videoStreamingUrl: '',
		tokenExisted: false,
		thumbnailUrl: '',
		beginTimeValue: '',
		endTimeValue: '',
		timePickerDialogVisible: false,
		timeparam: 'begin',
		playEnable: 0,
	}),
	created() {
		const token = this.$store.getters.getToken;
		if(token) {
			this.tokenExisted = true;
		} else {
			this.tokenExisted = false;
		}
	},
	mounted() {
		if(this.$store.state.userData.user.token) {
			this.getCameraList();
		}
		this.getCurrentTime();
		console.log('UI Test');
	},
	methods: {
		async goVideoTest() {
			await this.getStreamingUrl(this.streamList[this.playEnable].streamName);
    },
		goWebRTCVideo() {
			this.pushRoute('/test/webrtc-video-player', {});
		},
		goMultiVideoTest(viewCount, type) {
      this.pushRoute('/test/multi-player', { viewCount: viewCount, type: type });
    },
    goWebRTCTest() {
      this.pushRoute('/test/videojs-webrtc', {});
    },
		goVideoThumbnailTest() {
      this.pushRoute('/test/video-thumbnail', {});
    },
		goFabricTest() {
			this.pushRoute('/test/fabric-test', {thumbnailUrl: this.thumbnailUrl});
		},
		testToast() {
			this.$dialog.message.info('Custom Toast Test', {
				centered: true, timeout: 2500, color: '#1D202C'
			});
		},
		async testInfoDialog() {
			await this.$dialog.info({
				text: 'File copied successfully',
				title: 'Info'
			});
		},
		async testConfirmDialog() {
			await this.$dialog.confirm({
				text: 'Test ConfirmDialog',
				title: 'Test',
				actions: {
					false: { color: 'white', text: 'Cancel',},
					true: {
						color: 'white', text: 'Confirm',
						handle: () => {
							
						}
					}
				}
			});
		},
		testOverlayLoading() {
			// Overlay Loading 호출
			this.$vloading.show();
			setTimeout(() => {
				// Overlay Loading 숨기기
				this.$vloading.hide();
			}, 2000);
		},
		async getCameraList() {
			this.streamingUrlLoading = true;
			let params = {};
			await this.networkController.getDashboardCameraList(params)
			.then(async (res) => {
				console.log('%cCamera List\n', "color:#008DD0;", res.data);
				this.streamList = res.data;
				for(let i=0; i<this.streamList.length; i++) {
					if(this.streamList[i].isOnline) {
						this.thumbnailUrl = this.streamList[i].thumbnail;
						this.playEnable = i;
						break;
					}
				}
				this.streamingUrlLoading = false;
			}).catch(error => {
				this.streamingUrlLoading = false;
			});
		},
		async getStreamingUrl(streamName) {
			this.streamingUrlLoading = true;
			let params = {};
			await this.networkController.getHlsStreamingUrl(params, streamName, '', '').then(async (res) => {
				console.log('%cStreaming URL\n', "color:#008DD0;",res.data);
				await this.$store.commit('setVideoStreamingUrl', res.data.hlsstreamingSessionURL);
				this.streamingUrlLoading = false;
				this.pushRoute('/test/video-player', {});
			}).catch(error => {
				this.streamingUrlLoading = false;
				this.$dialog.message.error(this.tmb('requestFail'), {
					position: 'top', timeout: 3000
				});
			});
		},
		getCurrentTime() {
			let date = new Date();
			let beginDate = new Date();
			beginDate.setHours(beginDate.getHours() - 1);
			let hourStr = date.getHours() < 10 ? `0${date.getHours()}` : date.getHours();
			let beginHourStr = beginDate.getHours() < 10 ? `0${beginDate.getHours()}` : beginDate.getHours();
			let minuteStr = date.getMinutes() < 10 ? `0${date.getMinutes()}` : date.getMinutes();
			let secondStr = date.getSeconds() < 10 ? `0${date.getSeconds()}` : date.getSeconds();
			this.beginTimeValue = `${beginHourStr}:${minuteStr}:${secondStr}`;
			this.endTimeValue = `${hourStr}:${minuteStr}:${secondStr}`;
		},
		openTimePicker(time) {
			this.timeparam = time;
			this.timePickerDialogVisible = true;
		},
		timePickerDialogVisibleFunc(visible) {
			this.timePickerDialogVisible = visible;
		},
		timeValueFunc(time) {
			if(this.timeparam == 'begin') {
				this.beginTimeValue = time;
			} else {
				this.endTimeValue = time;
			}
		}
	}
}
</script>

<style lang="scss" scoped>
#middle_divider {
	background-color: #4C4C4C;
}
.v-list {
  background: #171921 !important;
	border: 1px solid #4A4A4A;
}	
::v-deep {
	.v-list-item{
    min-height: 0px;
    color: white !important;
  }
	// Select box v화살표 위치
	.v-input__slot {
		padding-right: 2px !important;
	}
	.v-input__append-inner {
		margin-top: 16px !important;
		padding-left: 0px !important;
	}
}
</style>